var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoxWhiteOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7931 0.3066C12.9715 -0.102199 12.0285 -0.1022 11.2069 0.306599L0.610622 5.57866C0.238753 5.76368 0 6.16954 0 6.61666V17.5156C0 18.8411 0.69958 20.0472 1.79545 20.6112L12.0568 25.8917C12.3333 26.0339 12.6529 26.0362 12.931 25.8978L23.1681 20.8044C24.2837 20.2494 25 19.0318 25 17.6904V6.61666C25 6.16954 24.7612 5.76368 24.3894 5.57866L13.7931 0.3066ZM12.931 2.38259C12.6572 2.24633 12.3428 2.24633 12.069 2.38259L3.55897 6.61666L5.87993 7.77143L14.7839 3.30445L12.931 2.38259ZM18.5495 5.17802L9.6456 9.645L12.5 11.0652L21.441 6.61666L18.5495 5.17802ZM22.9167 8.38739L13.5417 13.0518V23.0891L22.306 18.7284C22.6779 18.5434 22.9167 18.1376 22.9167 17.6904V8.38739ZM11.4583 23.0638V13.0518L8.85417 11.7561V21.7237L11.4583 23.0638ZM4.6875 19.5796V9.68307L2.08333 8.38739V17.5156C2.08333 17.9574 2.31653 18.3595 2.68181 18.5475L4.6875 19.5796Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxWhiteOutline);
export default __webpack_public_path__ + "static/media/boxWhiteOutline.fe47b4cb6cc3cc5e3420ad2472355c79.svg";
export { ForwardRef as ReactComponent };